<template>
  <div class="d-flex vh-100 vw-80 flex-column justify-content-center align-items-center">
    <div class="d-flex justify-content-center align-items-center">
      <img src="public/questionnaire_submited.svg" alt="" class="questionnaire-submited-icon">
    </div>
    <div class="header header-2 mt-5">
      <span class="semi-bold bigger">{{$t('headers.goodbye')}}</span>
      <br>
      <span>{{$t('headers.goodbye_message')}}</span>
    </div>
  </div>
</template>
<script>
export default {
  mounted () {
    // this.$ga.event({
    //   eventCategory: 'questionnaire',
    //   eventAction: 'contact-form',
    //   eventLabel: 'Submetido',
    //   eventValue: 1
    // })
  }
}
</script>

<style lang="scss" scoped>

.questionnaire-submited-icon {
  height: 200px;
  margin-left: 20px;
  max-height: 50vh;
  max-width: 80vw;
}

.bigger {
  font-size: 2rem;
}

.vh-100 {
  min-height: 100vh!important;
}

.vw-80 {
  max-width: 80vw!important;
  margin: auto;
}
</style>